import { AlertUtil } from './../utils/alert-util';
import { IAggiudicatario } from './../interfaces/IAggiudicatario';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { AggiudicatarioService } from '../services/aggiudicatario.service';
import { finalize } from 'rxjs/operators';
import * as Constants from '../utils/constants';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/api';
import { AggiudicatarioModalComponent } from '../aggiudicatario-modal/aggiudicatario-modal.component';


@Component({
  selector: 'app-aggiudicatari',
  templateUrl: './aggiudicatari.component.html',
  styleUrls: ['./aggiudicatari.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AggiudicatariComponent implements OnInit {
  aggiudicatari: IAggiudicatario[]  // table data source
  rowSelected: boolean = false    //determines whether one commessa row has been clicked
  aggiudicatario: IAggiudicatario

  isCSE: boolean //determines whether the user logged is cse 
  isDL: boolean //determines whether the user logged is dl
  isAdmin: boolean //determines whether the user logged is admin

  disableAggiudicatarioTooltip: boolean = true // show tooltip aggiudicatario

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  constructor(private aggiudicatarioService: AggiudicatarioService,
    private translate: TranslateService, private dialogService: DialogService, private alertUtil: AlertUtil,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.checkUserRole(userRole)
    setTimeout(() => {
      this.getAllAggiudicatari()
    }, 0);
  }


  /**
   * get all aggiudicatari
   */
  getAllAggiudicatari() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.aggiudicatarioService.getAllAggiudicatari(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.aggiudicatari = response.data
          this.cd.markForCheck();
          this.getCommesseAssociateFromResponse()
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * get commesse associate all'aggiudicatario
   */
  getCommesseAssociateFromResponse() {
    let commesseString = " "
    for (let i = 0; i < this.aggiudicatari.length; i++) {//ciclo gli aggiudicatari
      let aggiudicatario = this.aggiudicatari[i]
      if (aggiudicatario.Commesse) { //Controllo se Commesse è valorizzato
        if (aggiudicatario.Commesse[0].Id == -1) { // se la prima commessa ha id -1 non ci sono commesse associate
          aggiudicatario.Commessa = "Nessuna commessa associata"
        } else {
          for (let y = 0; y < aggiudicatario.Commesse.length; y++) { // ciclo commesse associate
            let commessa = aggiudicatario.Commesse[y]
            commesseString += commessa.Nome + "," //costruisco la stringa delle commesse associate
          }
          commesseString = commesseString.slice(0, -1); // rimuovo l'ultima virgola
          aggiudicatario.Commessa = commesseString  // associo la stringa al campo commessa
          commesseString = ""
        }
      }
    }
  }

  onRowSelected(aggiudicatario: IAggiudicatario) {
  }

  onRowUnselected() {
    this.rowSelected = false
  }


  /**
 * open new aggiudicatario modal
 */
  openAggiudicatarioModal(isUpdate: boolean) {
    let modalTitle = "LBL_NEW_AGGIUDICATARIO"
    if (isUpdate) {
      modalTitle = "LBL_UPDATE_AGGIUDICATARIO"
    }
    //get header translation
    this.translate.get(modalTitle).subscribe(res => {
      let aggiudicatario = this.aggiudicatario
      //open aggiudicatari modal
      let aggiudicatarioModal = this.dialogService.open(AggiudicatarioModalComponent, {
        data: { aggiudicatario, fromFiliera: false },
        header: res,
        width: '50%'
      })

      // refresh aggiudicatari when modal is closed and newAggiudicatario is created
      aggiudicatarioModal.onClose.subscribe((aggiudicatarioObj) => {
        if (aggiudicatarioObj) {
          this.getAllAggiudicatari()
        }
      })
    })
  }

  onCreateAggiudicatario() {
    this.aggiudicatario = null
    this.openAggiudicatarioModal(false)
  }

  onUpdateAggiudicatario(aggiudicatarioForUpdate: IAggiudicatario) {
    this.aggiudicatario = aggiudicatarioForUpdate
    this.openAggiudicatarioModal(true)
  }

  /**
  * check role of user logged
  */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.CSE) {
      this.isCSE = true
      this.disableAggiudicatarioTooltip = false
    } else if (userRole == Enum.USER_TYPE_ENUM.DL) {
      this.isDL = true
      this.disableAggiudicatarioTooltip = false
    } else if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true
      this.disableAggiudicatarioTooltip = false
    }
  }
}
